export const trLocaleText = {
    cancelButtonLabel: "İptal",
    clearButtonLabel: "Temizle",
    okButtonLabel: "Tamam",
    todayButtonLabel: "Bugün",
};

export const enLocaleText = {
    cancelButtonLabel: "Cancel",
    clearButtonLabel: "Clear",
    okButtonLabel: "OK",
    todayButtonLabel: "Today",
};
